import {
  AuthActions,
  AuthStateAgentInfo,
  selectAllEntitiesWithPlaceHolder,
  selectLoggedUser,
} from 'store/modules/auth';
import { ChannelType, EntitiesForm, Entity } from 'core/entities';
// eslint-disable-next-line
import React, { FC, useState } from 'react';

import FirstImageLogin from 'assets/images/login-img-firstpage.png';
import { Formik } from 'formik';
import Grid from '@material-ui/core/Grid';
import Layout from 'components/Layout';
import Paper from '@material-ui/core/Paper';
import { RootState } from 'store/root-reducer';
import Typography from '@material-ui/core/Typography';
import Yup from 'config/yup-locale';
import { regexNumbersWithoutFirstCero } from 'utils/helpers';
import { useAppDispatch } from 'store';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import dictionary from 'utils/dictionary';
import useStyles from './Login.styles';
import { useGetSellerRole, useUserRole } from 'core/auth/hooks';
import { Roles } from 'core/auth';

type FormikInitialValues = { entity: string; dni: string };

export const validationSchema = (
  entities: Entity[],
  sellerInfo?: AuthStateAgentInfo
) =>
  Yup.object({
    entity: Yup.string().required(
      'Debe seleccionar entidad para poder continuar'
    ),
    dni: Yup.string()
      .trim()
      .matches(
        regexNumbersWithoutFirstCero,
        'El documento no debe comenzar con 0'
      )
      .min(
        5,
        'El documento debe tener al menos 5 números. Por favor reintente.'
      )
      .max(8)
      .when('entity', (entityID, schema) => {
        return entities.find(
          ({ id, channelType }) =>
            id === entityID && channelType === ChannelType.Indirect
        )
          ? schema.required('Debe completar el documento')
          : schema;
      })
      .test(
        'is-not-active-seller',
        'La CI no pertenece a un vendedor activo.',
        (value) => {
          if (sellerInfo) {
            return sellerInfo?.status === 'ACTIVO';
          }
          return true;
        }
      ),
  });

const EntitiesPage: FC = () => {
  const classes = useStyles();
  const dispatch = useAppDispatch();
  const user = useSelector(selectLoggedUser);
  const selectedEntityId = useSelector(
    (state: RootState) => state.auth.selectedEntityId
  );
  const authEntities = useSelector(selectAllEntitiesWithPlaceHolder);
  const history = useHistory();

  const [sellerInfo, setSellerInfo] = useState<AuthStateAgentInfo>();

  const sellerRole = useGetSellerRole([
    Roles.FIJASTH_PY_VENTAS,
    Roles.FIJASTH_PY_EXCEPCION,
  ]);
  const isSellerRole = useUserRole([sellerRole]);
  const isClaroTvRole = useUserRole([
    Roles.DTHSTH_PY_VENTAS,
    Roles.DTHSTH_PY_EXCEPCION,
  ]);

  const initialValues: FormikInitialValues = {
    entity: selectedEntityId,
    dni: '',
  };

  const handleSubmit = (values: FormikInitialValues) => {
    if (values.entity) {
      dispatch(AuthActions.selectEntity(values.entity));
      if (isSellerRole) {
        history.push('/dashboard');
      } else if (isClaroTvRole) {
        history.push('/claro-tv');
      }
    }
  };

  const handleBack = () => {
    dispatch(AuthActions.logout());
  };

  return (
    <Layout>
      <Paper className={classes.paper}>
        <Grid container spacing={0}>
          <Grid item className={classes.grid} xs={12} sm={6}>
            <Typography className={classes.title} variant="h5" component="h1">
              {dictionary.entitiesPage_title}
            </Typography>
            <Typography
              className={classes.userName}
              variant="h5"
              component="h1"
            >
              {user?.displayName}
            </Typography>
            <Typography
              className={classes.subtitle}
              variant="body2"
              component="h2"
            >
              {dictionary.entitiesPage_subtitle}
            </Typography>
            <Formik
              validationSchema={validationSchema(authEntities, sellerInfo)}
              initialValues={initialValues}
              onSubmit={handleSubmit}
            >
              <EntitiesForm
                handleBack={handleBack}
                gridClass={classes.entityForm}
                data={authEntities}
                sellerInfo={sellerInfo}
                onLoadSellerInfo={setSellerInfo}
              />
            </Formik>
          </Grid>
          <Grid className={classes.grid2} item xs={12} sm={6}>
            <img alt="complex" src={FirstImageLogin} />
          </Grid>
        </Grid>
      </Paper>
    </Layout>
  );
};

export default EntitiesPage;
